export default __webpack_public_path__ + "static/media/team7.e07ea3bf.png";